import type { Routes } from '@angular/router';

export const TOTEMS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/nfcs/views/totems/totems.component').then((m) => m.TotemsComponent),
    },
];
